'use client';

import AllTextPage from '@/app/(with-metadata)/shared/text/AllTextPage';

export default function TextTwoPage() {
  return <AllTextPage textNumber='text2' />;
}
